{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            Copyright (c) 2022                                      }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.Country;

{$DEFINE NOPP}

interface

uses
  Classes, Web, JS, WEBLib.Controls, WEBLib.StdCtrls, WEBLib.ExtCtrls, WEBLib.DropDown;

type
  TCountryComboBox = class(TCustomComboBox)
  public
    procedure CreateInitialize; override;
    property Items;
  published
    property Align;
    property AlignWithMargins;
    property Anchors;
    property BiDiMode;
    property ChildOrder;
    property Color;
    property DragMode;
    property ElementClassName;
    property ElementID;
    property ElementFont;
    property ElementPosition;
    property Enabled;
    property Font;
    property Height;
    property HeightPercent;
    property HeightStyle;
    property Hint;
    property ItemIndex;
    property Left;
    property ParentFont;
    property Role;
    property ShowFocus;
    property ShowHint;
    property Style;
    property TabOrder;
    property TabStop;
    property Text;
    property TextDirection;
    property TextHint;
    property Top;
    property Visible;
    property Width;
    property WidthPercent;
    property WidthStyle;
    property OnChange;
    property OnClick;
    property OnDblClick;
    property OnKeyDown;
    property OnKeyPress;
    property OnKeyUp;
    property OnMouseDown;
    property OnMouseUp;
    property OnMouseMove;
    property OnMouseLeave;
    property OnMouseEnter;
    property OnEnter;
    property OnExit;
    property OnDragDrop;
    property OnDragOver;
    property OnEndDrag;
    property OnStartDrag;
  end;

  TWebCountryComboBox = class(TCountryComboBox);

  TCountryListBox = class(TCustomListBox)
  private
    FLastSelected: TJSElement;
    FItemIndex: integer;
    FFilter: string;
    procedure SetFilter(const Value: string; CaseSensitive: boolean = true); overload;
    procedure SetFilter(const Value: string); overload;
  protected
    procedure CreateInitialize; override;
    procedure DoUpdateList; override;
    function HandleDoClick(Event: TJSMouseEvent): Boolean; override;
    function GetItemIndex: integer; override;
    procedure SetItemIndex(const AIndex: integer); override;
  public
    property ItemHeight;
    property Items;
    property Filter: string read FFilter write SetFilter;
  published
    property Align;
    property AlignWithMargins;
    property Anchors;
    property BiDiMode;
    property ChildOrder;
    property Color;
    property DragMode;
    property ElementClassName;
    property ElementID;
    property ElementFont;
    property ElementPosition;
    property Enabled;
    property Font;
    property Height;
    property HeightPercent;
    property HeightStyle;
    property Hint;
    property ItemIndex;
    property Left;
    property ParentFont;
    property Role;
    property ShowFocus;
    property ShowHint;
    property TabOrder;
    property TabStop;
    property TextDirection;
    property Top;
    property Visible;
    property Width;
    property WidthPercent;
    property WidthStyle;
    property OnChange;
    property OnClick;
    property OnDblClick;
    property OnKeyDown;
    property OnKeyPress;
    property OnKeyUp;
    property OnMouseDown;
    property OnMouseUp;
    property OnMouseMove;
    property OnMouseLeave;
    property OnMouseEnter;
    property OnEnter;
    property OnExit;
    property OnDragDrop;
    property OnDragOver;
    property OnEndDrag;
    property OnStartDrag;
  end;

  TWebCountryListBox = class(TCountryListBox);

  TDropDownEditChangeEvent = procedure(Sender: TObject; AValue: string) of object;

  TCountryDropDown = class(TEditDropDownControl)
  private
    FDoEditChange: pointer;
    FDoEditKeyDown: pointer;
    FCountryList: TWebCountryListBox;
    FOnEditChange: TDropDownEditChangeEvent;
  protected
    function HandleDoEditChange(Event: TJSEvent): Boolean; virtual;
    function HandleDoEditKeyDown(Event: TJSKeyBoardEvent): Boolean; virtual;
    procedure ClearMethodPointers; override;
    procedure GetMethodPointers; override;
    procedure CreateInitialize; override;
    function HasEdit: boolean; override;
    procedure DoDropDown; override;
    procedure DoCloseUp; override;
    procedure DoEditChange; virtual;
  public
    procedure ShowDropDown; override;
  published

    property OnEditChange: TDropDownEditChangeEvent read FOnEditChange write FOnEditChange;
    property OnClick;
    property OnDblClick;
    property OnKeyDown;
    property OnKeyPress;
    property OnKeyUp;
    property OnMouseDown;
    property OnMouseUp;
    property OnMouseMove;
    property OnMouseLeave;
    property OnMouseEnter;
    property OnEnter;
    property OnExit;
    property OnDragDrop;
    property OnDragOver;
    property OnEndDrag;
    property OnStartDrag;
  end;

  TWebCountryDropDown = class(TCountryDropDown);

function GetCountryList: TJSObject;
function GetCountryCode(ACountry: string): string;
function GetCountryByCode(ACode: string): string;

implementation

uses
  SysUtils;

function GetCountryList: TJSObject;
var
  lst: TJSObject;
begin
  asm
    const countryListAlpha2 = {
    "AF": "Afghanistan",
    "AL": "Albania",
    "DZ": "Algeria",
    "AS": "American Samoa",
    "AD": "Andorra",
    "AO": "Angola",
    "AI": "Anguilla",
    "AQ": "Antarctica",
    "AG": "Antigua and Barbuda",
    "AR": "Argentina",
    "AM": "Armenia",
    "AW": "Aruba",
    "AU": "Australia",
    "AT": "Austria",
    "AZ": "Azerbaijan",
    "BS": "Bahamas",
    "BH": "Bahrain",
    "BD": "Bangladesh",
    "BB": "Barbados",
    "BY": "Belarus",
    "BE": "Belgium",
    "BZ": "Belize",
    "BJ": "Benin",
    "BM": "Bermuda",
    "BT": "Bhutan",
    "BO": "Bolivia (Plurinational State of)",
    "BQ": "Bonaire, Sint Eustatius and Saba",
    "BA": "Bosnia and Herzegovina",
    "BW": "Botswana",
    "BV": "Bouvet Island",
    "BR": "Brazil",
    "IO": "British Indian Ocean Territory",
    "BN": "Brunei Darussalam",
    "BG": "Bulgaria",
    "BF": "Burkina Faso",
    "BI": "Burundi",
    "CV": "Cabo Verde",
    "KH": "Cambodia",
    "CM": "Cameroon",
    "CA": "Canada",
    "KY": "Cayman Islands",
    "CF": "Central African Republic",
    "TD": "Chad",
    "CL": "Chile",
    "CN": "China",
    "CX": "Christmas Island",
    "CC": "Cocos (Keeling) Islands",
    "CO": "Colombia",
    "KM": "Comoros",
    "CD": "Congo (the Democratic Republic of)",
    "CG": "Congo",
    "CK": "Cook Islands",
    "CR": "Costa Rica",
    "HR": "Croatia",
    "CU": "Cuba",
    "CW": "Curaçao",
    "CY": "Cyprus",
    "CZ": "Czechia",
    "CI": "Côte d'Ivoire",
    "DK": "Denmark",
    "DJ": "Djibouti",
    "DM": "Dominica",
    "DO": "Dominican Republic",
    "EC": "Ecuador",
    "EG": "Egypt",
    "SV": "El Salvador",
    "GQ": "Equatorial Guinea",
    "ER": "Eritrea",
    "EE": "Estonia",
    "SZ": "Eswatini",
    "ET": "Ethiopia",
    "FK": "Falkland Islands [Malvinas]",
    "FO": "Faroe Islands",
    "FJ": "Fiji",
    "FI": "Finland",
    "FR": "France",
    "GF": "French Guiana",
    "PF": "French Polynesia",
    "TF": "French Southern Territories",
    "GA": "Gabon",
    "GM": "Gambia",
    "GE": "Georgia",
    "DE": "Germany",
    "GH": "Ghana",
    "GI": "Gibraltar",
    "GR": "Greece",
    "GL": "Greenland",
    "GD": "Grenada",
    "GP": "Guadeloupe",
    "GU": "Guam",
    "GT": "Guatemala",
    "GG": "Guernsey",
    "GN": "Guinea",
    "GW": "Guinea-Bissau",
    "GY": "Guyana",
    "HT": "Haiti",
    "HM": "Heard Island and McDonald Islands",
    "VA": "Holy See",
    "HN": "Honduras",
    "HK": "Hong Kong",
    "HU": "Hungary",
    "IS": "Iceland",
    "IN": "India",
    "ID": "Indonesia",
    "IR": "Iran (Islamic Republic of)",
    "IQ": "Iraq",
    "IE": "Ireland",
    "IM": "Isle of Man",
    "IL": "Israel",
    "IT": "Italy",
    "JM": "Jamaica",
    "JP": "Japan",
    "JE": "Jersey",
    "JO": "Jordan",
    "KZ": "Kazakhstan",
    "KE": "Kenya",
    "KI": "Kiribati",
    "KP": "Korea (the Democratic People's Republic of)",
    "KR": "Korea (the Republic of)",
    "KW": "Kuwait",
    "KG": "Kyrgyzstan",
    "LA": "Lao People's Democratic Republic",
    "LV": "Latvia",
    "LB": "Lebanon",
    "LS": "Lesotho",
    "LR": "Liberia",
    "LY": "Libya",
    "LI": "Liechtenstein",
    "LT": "Lithuania",
    "LU": "Luxembourg",
    "MO": "Macao",
    "MG": "Madagascar",
    "MW": "Malawi",
    "MY": "Malaysia",
    "MV": "Maldives",
    "ML": "Mali",
    "MT": "Malta",
    "MH": "Marshall Islands",
    "MQ": "Martinique",
    "MR": "Mauritania",
    "MU": "Mauritius",
    "YT": "Mayotte",
    "MX": "Mexico",
    "FM": "Micronesia (Federated States of)",
    "MD": "Moldova (the Republic of)",
    "MC": "Monaco",
    "MN": "Mongolia",
    "ME": "Montenegro",
    "MS": "Montserrat",
    "MA": "Morocco",
    "MZ": "Mozambique",
    "MM": "Myanmar",
    "NA": "Namibia",
    "NR": "Nauru",
    "NP": "Nepal",
    "NL": "Netherlands",
    "NC": "New Caledonia",
    "NZ": "New Zealand",
    "NI": "Nicaragua",
    "NE": "Niger",
    "NG": "Nigeria",
    "NU": "Niue",
    "NF": "Norfolk Island",
    "MP": "Northern Mariana Islands",
    "NO": "Norway",
    "OM": "Oman",
    "PK": "Pakistan",
    "PW": "Palau",
    "PS": "Palestine, State of",
    "PA": "Panama",
    "PG": "Papua New Guinea",
    "PY": "Paraguay",
    "PE": "Peru",
    "PH": "Philippines",
    "PN": "Pitcairn",
    "PL": "Poland",
    "PT": "Portugal",
    "PR": "Puerto Rico",
    "QA": "Qatar",
    "MK": "Republic of North Macedonia",
    "RO": "Romania",
    "RU": "Russian Federation",
    "RW": "Rwanda",
    "RE": "Réunion",
    "BL": "Saint Barthélemy",
    "SH": "Saint Helena, Ascension and Tristan da Cunha",
    "KN": "Saint Kitts and Nevis",
    "LC": "Saint Lucia",
    "MF": "Saint Martin (French part)",
    "PM": "Saint Pierre and Miquelon",
    "VC": "Saint Vincent and the Grenadines",
    "WS": "Samoa",
    "SM": "San Marino",
    "ST": "Sao Tome and Principe",
    "SA": "Saudi Arabia",
    "SN": "Senegal",
    "RS": "Serbia",
    "SC": "Seychelles",
    "SL": "Sierra Leone",
    "SG": "Singapore",
    "SX": "Sint Maarten (Dutch part)",
    "SK": "Slovakia",
    "SI": "Slovenia",
    "SB": "Solomon Islands",
    "SO": "Somalia",
    "ZA": "South Africa",
    "GS": "South Georgia and the South Sandwich Islands",
    "SS": "South Sudan",
    "ES": "Spain",
    "LK": "Sri Lanka",
    "SD": "Sudan",
    "SR": "Suriname",
    "SJ": "Svalbard and Jan Mayen",
    "SE": "Sweden",
    "CH": "Switzerland",
    "SY": "Syrian Arab Republic",
    "TW": "Taiwan",
    "TJ": "Tajikistan",
    "TZ": "Tanzania, United Republic of",
    "TH": "Thailand",
    "TL": "Timor-Leste",
    "TG": "Togo",
    "TK": "Tokelau",
    "TO": "Tonga",
    "TT": "Trinidad and Tobago",
    "TN": "Tunisia",
    "TR": "Turkey",
    "TM": "Turkmenistan",
    "TC": "Turks and Caicos Islands",
    "TV": "Tuvalu",
    "UG": "Uganda",
    "UA": "Ukraine",
    "AE": "United Arab Emirates",
    "GB": "United Kingdom of Great Britain and Northern Ireland",
    "UM": "United States Minor Outlying Islands",
    "US": "United States of America",
    "UY": "Uruguay",
    "UZ": "Uzbekistan",
    "VU": "Vanuatu",
    "VE": "Venezuela",
    "VN": "Viet Nam",
    "VG": "Virgin Islands (British)",
    "VI": "Virgin Islands (U.S.)",
    "WF": "Wallis and Futuna",
    "EH": "Western Sahara",
    "YE": "Yemen",
    "ZM": "Zambia",
    "ZW": "Zimbabwe",
    "AX": "Åland Islands"
    };
    lst = countryListAlpha2;
  end;

  Result := lst;

end;

{ TCountryComboBox }
{$HINTS OFF}
procedure TCountryComboBox.CreateInitialize;
var
  l: TJSObject;
  sl: TStrings;
begin
  inherited;
  l := GetCountryList;

  Items.Clear;
  sl := Items;

  asm
    for (var key in l) {
    if (l.hasOwnProperty(key)) {
        sl.Add(l[key]);
    }
    }
  end;
end;


function GetCountryCode(ACountry: string): string;
var
  l: TJSObject;
  s: string;
  res: string;
begin
  l := GetCountryList;
  res := '';

  asm
    s = ACountry.toUpperCase();
    for (var key in l) {
    if (l.hasOwnProperty(key)) {
        if (l[key].toUpperCase() == s)
          res = key;
    }
    }
  end;
  Result := res;
end;

function GetCountryByCode(ACode: string): string;
var
  l: TJSObject;
  res: string;
begin
  l := GetCountryList;
  res := '';

  asm
    if (l.hasOwnProperty(ACode)) { res = l[ACode]; }
  end;

  Result := res;
end;

{$HINTS ON}

{ TCountryList }

{$HINTS OFF}
procedure TCountryListBox.CreateInitialize;
var
  l: TJSObject;
  sl: TStrings;
  s: string;
begin
  inherited;
  l := GetCountryList;

  Items.Clear;
  sl := Items;

  asm
    for (var key in l) {
    if (l.hasOwnProperty(key)) {
        sl.Add(l[key]);
    }
    }
  end;

  s := '.tcountrylistboxselected {background: Highlight; color: HighlightText;}';
  AddControlStyle(s);
end;
{$HINTS ON}

procedure TCountryListBox.DoUpdateList;
var
  i: integer;
  opt, flg: TJSHTMLElement;
  txt: TJSNode;
begin
  if not Assigned(Container) then
    Exit;

  if IsUpdating then
    Exit;

  if ElementHandle.tagName <> 'DIV' then
    Exit;

  // remove previous content
  while Assigned(Container.firstChild) do
    Container.removeChild(Container.lastChild);

  for i := 0 to Items.Count - 1 do
  begin
    opt := TJSHTMLElement(document.createElement('LABEL'));

    flg := TJSHTMLElement(document.createElement('DIV'));

    flg['class'] := 'flag-icon-background flag-icon-' + Lowercase(GetCountryCode(Items[i]));
    flg.style.setProperty('width','20px');
    flg.style.setProperty('height','20px');
    flg.style.setProperty('display','inline-block');

    flg.style.setProperty('vertical-align','middle');
    flg.style.setProperty('margin-right','4px');
    opt.style.setProperty('vertical-align','middle');

    opt.appendChild(flg);

    opt.style.setProperty('display','block');
    txt := document.createTextNode(Items[i]);

    opt.appendChild(txt);

    if ElementItemClassName <> '' then
      opt['class'] := ElementItemClassName;

    if DragMode = dmAutomatic then
      opt['draggable'] := 'true';

    Container.appendChild(opt);
  end;

  UpdateElementData;
end;


function TCountryListBox.GetItemIndex: integer;
begin
  Result := FItemIndex;
end;

{$HINTS OFF}
function TCountryListBox.HandleDoClick(Event: TJSMouseEvent): Boolean;
var
  el: TJSHTMLCollection;
  sel: TJSElement;
  index: integer;
begin
  if Assigned(FLastSelected) then
  begin
    FLastSelected.classList.remove('tcountrylistboxselected');
  end;

  if Assigned(Event.target) and (TJSElement(Event.target).tagName = 'DIV') then
  begin
    if TJSElement(Event.target).parentElement.tagName = 'LABEL' then
    begin
      FLastSelected := TJSElement(Event.target).parentElement;
      FLastSelected.classList.add('tcountrylistboxselected');
    end;
  end;


  if Assigned(Event.target) and (TJSElement(Event.target).tagName = 'LABEL') then
  begin
    FLastSelected := TJSElement(Event.target);
    FLastSelected.classList.add('tcountrylistboxselected');
  end;

  sel := FLastSelected;
  el := ElementHandle.children;

  asm
    index = Array.from(el).indexOf(sel);
  end;

  FItemIndex := index;

  Result := true;
end;
{$HINTS ON}

procedure TCountryListBox.SetFilter(const Value: string; CaseSensitive: boolean = true);
var
  i: integer;
  el: TJSHTMLElement;
  srch,itm: string;
begin
  FFilter := Value;


  if not CaseSensitive then
    srch := Uppercase(Value)
  else
    srch := Value;

  for i := 0 to ElementHandle.children.length - 1 do
  begin
    el := TJSHTMLElement(ElementHandle.children[i]);

    if not CaseSensitive then
      itm := Uppercase(el.textContent)
    else
      itm := el.textContent;

    if Pos(srch, itm) > 0 then
      el.style.setProperty('display','block')
    else
      el.style.setProperty('display','none');
  end;
end;

procedure TCountryListBox.SetFilter(const Value: string);
begin
  SetFilter(Value, true);
end;

procedure TCountryListBox.SetItemIndex(const AIndex: integer);
begin
  FItemIndex := AIndex;

  if Assigned(FLastSelected) then
  begin
    FLastSelected.classList.remove('tcountrylistboxselected');
  end;

  if (AIndex >= 0) and (AIndex < ElementHandle.children.length) then
  begin
    FLastSelected := TJSElement(ElementHandle.children[AIndex]);
    FLastSelected.classList.add('tcountrylistboxselected');
  end;
end;

{ TCountryDropDown }

procedure TCountryDropDown.ClearMethodPointers;
begin
  inherited;
  FDoEditChange := nil;
  FDoEditKeyDown := nil;
end;

procedure TCountryDropDown.CreateInitialize;
begin
  inherited;
  FCountryList := TWebCountryListBox.Create(Self);
  FCountryList.Visible := false;
  FCountryList.Parent := Self;

  if (csDesigning in ComponentState) then
  begin
    FCountryList.Width := 0;
    FCountryList.Height := 0;
  end
  else
  begin
    FCountryList.Width := Width;
    FCountryList.Height := 400;
  end;

  EditElement.addEventListener('input',FDoEditChange);
  EditElement.addEventListener('keydown',FDoEditKeyDown);  

  Control := FCountryList;
  AutoDropDown := true;
end;

procedure TCountryDropDown.DoCloseUp;
begin
  if FCountryList.ItemIndex >= 0 then
    Text := FCountryList.Items[FCountryList.ItemIndex]
  else
    Text := '';
end;

procedure TCountryDropDown.DoDropDown;
begin
  FCountryList.ItemIndex := FCountryList.Items.IndexOf(Text);
end;

procedure TCountryDropDown.DoEditChange;
begin

end;

procedure TCountryDropDown.GetMethodPointers;
begin
  inherited;
  if FDoEditChange = nil then
  begin
    FDoEditChange := @HandleDoEditChange;
    FDoEditKeyDown := @HandleDoEditKeyDown;
  end;
end;

function TCountryDropDown.HandleDoEditChange(Event: TJSEvent): Boolean;
var
  i: integer;
  v: string;
  found: boolean;
begin
  if not DroppedDown and AutoDropDown then
    ShowDropDown;

  v := TJSHTMLInputElement(EditElement).value;

  if Assigned(OnEditChange) then
    OnEditChange(Self, v);

  FCountryList.SetFilter( v, false);

  v := Uppercase(v);

  found := false;

  for i := 0 to FCountryList.Count - 1 do
  begin
    if pos(v, Uppercase(FCountryList.Items[i])) > 0 then
    begin
      FCountryList.ItemIndex := i;
      found := true;
      Exit;
    end;
  end;

  if not found then
    FCountryList.ItemIndex := -1;

  Result := true;
end;

function TCountryDropDown.HandleDoEditKeyDown(Event: TJSKeyBoardEvent): Boolean;
var
  invis: boolean;
  i: integer;
  el: TJSHTMLElement;
begin
  if DroppedDown then
  begin
    if Event.key = 'Enter' then
    begin
      if FCountryList.ItemIndex <> -1 then
      begin
        Text := FCountryList.Items[FCountryList.ItemIndex];
        HideDropDown;
      end;
    end;

    if Event.key = 'Escape' then
    begin
      FCountryList.Filter := '';
      HideDropDown;
      Text := '';
    end;

    if (Event.key = 'ArrowDown') and (FCountryList.ItemIndex < FCountryList.Items.Count) then
    begin
      i := FCountryList.ItemIndex + 1;
      invis := true;

      repeat
        el := TJSHTMLElement(FCountryList.ElementHandle.children[i]);
        if Assigned(el) and (el.style.getPropertyValue('display') = 'none') then
        begin
          inc(i);
        end
        else
        begin
          invis := false;
          FCountryList.ItemIndex := i;
          Text := FCountryList.Items[i];
        end;

      until (invis = false) or (i >= FCountryList.Items.Count);

    end;

    if (Event.key = 'ArrowUp') and (FCountryList.ItemIndex > 0) then
    begin
      i := FCountryList.ItemIndex - 1;
      invis := true;

      repeat
        el := TJSHTMLElement(FCountryList.ElementHandle.children[i]);
        if Assigned(el) and (el.style.getPropertyValue('display') = 'none') then
        begin
          dec(i);
        end
        else
        begin
          invis := false;
          FCountryList.ItemIndex := i;
          Text := FCountryList.Items[i];
        end;

      until (invis = false) or (i = -1);

    end;
  end;
  Result := true;
end;

function TCountryDropDown.HasEdit: boolean;
begin
  Result := true;
end;

procedure TCountryDropDown.ShowDropDown;
begin
  if DropDownWidth > 0 then
    FCountryList.Width := DropDownWidth
  else
    FCountryList.Width := Width;
  inherited;

end;

end.
